import { DsImage } from '@ice-web-app/designSystem';
import { useCurrentUserStore } from '@ice-web-app/shared-store';
import { Stack } from '@mui/material';
import { Dispatch, FC, SetStateAction } from 'react';
import QuickLink from '../Links/QuickLink';
import MiniNavbarMenu from '../MiniNavbarMenu';

interface Props {
  anchorEl: HTMLElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
  setMenu: Dispatch<SetStateAction<'ecosystem' | 'microSystem' | 'member' | 'none'>>;
}

const MicroSystemMenu: FC<Props> = ({ anchorEl, setAnchorEl, setMenu }) => {
  const open = Boolean(anchorEl);
  const { currentEcosystem, currentMicroSystem, setCurrentMicrosystem } = useCurrentUserStore();

  return (
    <MiniNavbarMenu
      anchorEl={anchorEl}
      open={open}
      onClose={() => {
        setAnchorEl(null);
        setMenu('none');
      }}
      setAnchorEl={setAnchorEl}
    >
      <Stack direction="row" gap={1}>
        {currentEcosystem?.microsystems.map((microsys) => {
          return (
            <QuickLink
              key={microsys.name}
              icon={<DsImage imgUrl={microsys.logo} alt={microsys.name} sx={{ p: 1 }} />}
              text={microsys.name}
              width={92}
              isActive={currentMicroSystem?.name === microsys.name}
              onClick={() => {
                setCurrentMicrosystem(microsys);
                setMenu('member');
              }}
            />
          );
        })}
      </Stack>
    </MiniNavbarMenu>
  );
};
export default MicroSystemMenu;
